import "@babel/polyfill";

require('./style.scss');

// require('./event-specific-sass.scss');

// import SessionModal from './SessionModal';

// window._viewsReactModals = {
//    'evtx_session': SessionModal
// };